import Image from 'next/image';
import Link from 'next/link';

import { cn } from '@kit/ui/utils';

function LogoImage({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Image
        src="/images/favicon/logo.webp"
        alt="Edem AI"
        width={36}
        height={36}
        className="h-9 w-9 flex-shrink-0"
        priority
      />
      <span className="text-2xl tracking-wide">
        <span className="font-bold text-white">Edem</span>
        <span className="font-light text-white/70"> AI</span>
      </span>
    </div>
  );
}

export function AppLogo({
  href,
  label,
  className,
}: {
  href?: string | null;
  className?: string;
  label?: string;
}) {
  if (href === null) {
    return <LogoImage className={className} />;
  }

  return (
    <Link aria-label={label ?? 'Home Page'} href={href ?? '/'} prefetch={true}>
      <LogoImage className={className} />
    </Link>
  );
}
